
import React, { FC } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import {  Spin } from 'antd';
interface IProps {}

/**
* @author
* @function @
**/

export default (props) => {

  const {height} = props ;

  let divHeight = height ? height : '60vh';
  return (
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:divHeight,margin:'auto'}}>
   <div>
   <Spin indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />} />
   </div>
    </div>
   )
 }
